import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["placeholder"]
const _hoisted_2 = ["value"]

import { inject, onMounted, ref, watchEffect } from 'vue';
import type SlSelect from '@shoelace-style/shoelace/dist/components/select/select';
import { SolrFacet, SolrFacetOption } from '../../modules/solr'; // eslint-disable-line import/no-relative-parent-imports


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetOptionsMultiDropdown',
  props: {
    facet: {}
  },
  emits: ["changeMultiple"],
  setup(__props: any, { emit }) {

const props = __props;

const i18n = inject('i18n') as { [key: string]: string };

const multiSelect = ref<SlSelect | null>(null);





function key (option: SolrFacetOption): string {
    return `${option.label}|${option.value}|${option.selected ? 'y' : 'n'}}`;
}

function changeValue (event: CustomEvent): void {
    let values: string[] = [];
    const { value } = event.target as SlSelect;
    if (Array.isArray(value)) {
        values = value.map((item): string => {
            return decodeURIComponent(item);
        });
    } else {
        values.push(decodeURIComponent(value));
    }

    emit('changeMultiple', props.facet.name, values);
}

onMounted((): void => {
    // Set selected elements
    // if they have been aready selected by another component before, for example on resize
    if (props.facet.selected) {
        const selectedValues: string[] = [];

        for (const option in props.facet.options) { // eslint-disable-line @typescript-eslint/no-for-in-array
            if (props.facet.options[option].selected) {
                selectedValues.push(props.facet.options[option].value);
            }
        }

        if (multiSelect.value) {
            multiSelect.value.value = selectedValues;
        }
    }
});

watchEffect((): void => {
    // Reset the value property of the multi select element
    if (!props.facet.selected && multiSelect.value) {
        multiSelect.value.value = '';
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("sl-select", {
    ref_key: "multiSelect",
    ref: multiSelect,
    placeholder: _unref(i18n).moreFilters,
    "max-options-visible": 0,
    multiple: "",
    onSlChange: changeValue
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.facet.options, (option) => {
      return (_openBlock(), _createElementBlock("sl-option", {
        key: key(option),
        value: option.value
      }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
}
}

})